import React from 'react';
import { timeConvert } from '@/helpers/timeHelper';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import { Badge, Button } from 'antd';
import { useRouter } from 'next/router';

const MockTestItem = ({ item }) => {
  const { isGalaxyZFold, isMobile }: IBooleanArgs = useWidth();
  const router = useRouter();

  return (
    <div
      className={`${isMobile ? '' : 'my-4'} col-lg-12 col-sm-12`}
      key={item?.index}
    >
      <Badge.Ribbon text={item?.free ? 'Free' : 'Paid'} color="#c71a23">
        <div className={`bg-light border-14 ${isGalaxyZFold ? 'p-1' : ''}`}>
          <div className="d-flex">
            {!isGalaxyZFold && (
              <img
                width={112}
                alt="logo"
                src={
                  'https://d1k0ex3y89plmw.cloudfront.net/media/public/mocktest_uploads/2022_06_03_21_50_59_message.jpg'
                }
              />
            )}
            <div className="d-flex flex-column m-4" style={{ width: '80%' }}>
              <div className="d-flex justify-content-between">
                <h5 className="text-dark mb-2 pb-2 my-auto font-weight-bold">
                  <a href={item.href}>{item.title}</a>
                </h5>
                {/* <span className="bg-danger font-weight-500 text-white border-18 pl-3 pr-3 pt-1 pb-1 ml-3" style={{ fontSize: '12px' }}>Free</span> */}
              </div>
              <div className={`d-flex ${isMobile ? 'flex-column' : ''}`}>
                {item?.duration && (
                  <div className="mt-2 align-items-center mr-3">
                    <i className="far fa-clock"></i>{' '}
                    {parseFloat(item?.duration) > 60
                      ? timeConvert(item?.duration)
                      : item?.duration}
                  </div>
                )}
                {item?.total_questions > 0 && (
                  <div className="mt-2 mr-3">
                    <i className="far fa-question-circle"></i>{' '}
                    {Number(item?.total_questions)} Questions
                  </div>
                )}
                {item?.full_marks && (
                  <div className="mt-2 mr-3">
                    <i className="far fa-file-alt"></i> {Number(item?.full_marks)}{' '}
                    Marks
                  </div>
                )}
              </div>
              <div className={`d-flex ${isMobile ? 'flex-column' : ''}`}>
                {!item.free && item?.course && (
                  <div className="mock-course mr-2">
                    <span className="text-dark">Course:</span>{' '}
                    <span className="cursor-pointer">
                      <span className="course">{item?.course}</span>
                    </span>
                  </div>
                )}
                {/* {item.free && <Badge.Ribbon text="Free" color="#c71a23" />} */}
                {!item.free && item?.subject && (
                  <div className="mock-subject mt-2 ml-2">
                    <span className="text-dark">Subject:</span>{' '}
                    <span>
                      <span className="sub">{item?.subject}</span>
                    </span>
                  </div>
                )}
                {isMobile && (
                  <Button
                    size="large"
                    className="ant-btn ant-btn-default border-10 btn-outline-primary mt-2"
                    onClick={() => router.push(item.href)}
                  >
                    Start Now
                  </Button>
                )}
              </div>
            </div>
            {!isMobile && (
              <div className="ml-auto d-flex align-items-center mr-5">
                <Button
                  size="large"
                  className="ant-btn ant-btn-default border-10 btn-outline-primary"
                  onClick={() =>
                    item?.is_enrolled && item?.is_submitted
                      ? router.push(`/mock-test/reports/${item?.slug}`)
                      : router.push(item.href)
                  }
                >
                  {item?.is_enrolled && item?.is_submitted
                    ? 'View Report'
                    : 'Start Now'}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Badge.Ribbon>
    </div>
  );
};

export default MockTestItem;
